export const hospitalOccurrenceCodesColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'fk_hospital__clinical_id',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'occurrence_code',
  'occurrence_date',
  'snapshot_id',
];
